export const fetchSearchItems = async (searchFields, searchTerm, server, limit = 5, prefilter = [], sort = []) => {
    const filter = searchFields.map((field) => [
        {
            field: field,
            op: ':',
            value: searchTerm
        }
    ]);

    try {
        return await server.search(limit, filter, sort, prefilter);
    } catch (error) {
        return { error: error };
    }
};

export const fetchItemById = async (id, server, prefilter = []) => {
    const filter = [
        [
            {
                field: 'id',
                op: '=',
                value: id
            }
        ]
    ];

    try {
        return await server.search(5, filter, [], prefilter);
    } catch (error) {
        return { error: error };
    }
};